/**
 * @file defined a map that maps the states and their comments.
 * e.g. the value of 'comment.expressMode' is the comment that need to be put right above the corresponding variable of 'expressMode' in the Response File
 * @author Haonan Yu(haoyu@microStrategy.com)
 */

const comment = {};

comment.expressMode = `
######################################
## Strategy 11.6 Response File ##
######################################
#
# This file contains entries targeted to Custom Mode, which will install and configure the full platform on one machine.
#
# For more information on Silent Install please refer to the section on "Installing and configuring with a response.ini file" in the Installation and Configuration guide available at http://www2.microstrategy.com/producthelp/manuals/en/InstallationConfig.pdf.
#
# We are working to improve our Silent and Automated installation use-cases.  Feedback on Silent or Automated installations is welcomed via the Strategy Community (Platform Services > Platform > Secure Enterprise - Windows) or via Technical Support to the Deployment Team.
# Here is a direct link (as of Jun 2017) to the Community sub-section on platform deployment: https://success.microstrategy.com/s/topic/0TO44000000FlkJGAS/Secure%20Enterprise%20-%20Windows%20-%20U092?tabset-215d6=1
#
######################################
##		Usage		                ##
######################################
#
# In an Administrator Command Line window (Windows Button > CMD, Right Click and Run As Administrator)
#
# Silent Install Usage: #PathToSetupExe# --responseFile="#PathToResponseIni#" -s -f1#PathToSetupIss# -f2#PathToLogFile#
#
# Example: C:\\Setup.exe --responseFile="C:\\response_custom.ini" -s -f1C:\\Setup.iss -f2C:\\Setup.log
#
# This assumes the following:
#
# Setup.exe is located at: C:\\Setup.exe
# Strategy Response File is located at: C:\\response_custom.ini
# Installer Setup.iss is located at: C:\\Setup.iss
# Output Log file should be written to: C\\Setup.log
#
#
# Response entries start here, replace any text between angled brackets (<>) with your own text

[Installer]
`;

comment.forceReboot = `

# After initial installation is finished, choose whether to automatically reboot the machine.
# A reboot is required.
# TRUE  - Indicates the machine will automatically reboot (recommended)
# FALSE - Indicates that no automatic reboot will be performed.  Task Manager (setup.exe) or the Install.log may be used to determine once the installation is finished as no other indication will be provided.
`;

comment.logFile = `
###ConfigWizardResponseFile=Response.ini
# Path and File Name for the Installation Log file.
# If no value is specified, the default location will be used: C:\\Program Files (x86)\\Common Files\\MicroStrategy\\install.log
`;

comment.hideWelcomeDialog = `

[Welcome]
`;

comment.removeAll = `

## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ##
#
# You are about to completely uninstall Strategy and all of its features.
# 
# If Tomcat is installed:
# Removing Apache Tomcat will also remove any deployed web applications, potentially including Strategy Web, Strategy Mobile, Strategy Web Services and Strategy Library.
# 
# If Strategy Repository is installed:
# Removing Strategy Repository will delete all hosted databases set up for Platform Analytics, Collaboration or Library Storage if installed.
# If you are using Strategy Repository as your metadata repository, it will also be removed.
# 
# We recommend taking a backup using the Repository Administration Tool before uninstalling.
# 
## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ##
`;

comment.hideUserRegistrationDialog = `

## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ##
#
# Customer Information
#
# Please specify your first name, last name, email address, the name of the company
# for which you work and the license key.
#

[UserRegistration]
`;

comment.userFirstName = `

# First name of user
`;

comment.userLastName = `

# Last name of user
`;

comment.userEmail = `

# Email address of user
`;

comment.companyName = `

# Company
`;

comment.licenseKey = `

# License key
`;

comment.hideLicenseDetailDialog = `

[LicenseDetail]
`;

comment.hideSetupExpressDialog = `

[SetupExpress]
`;

comment.hideSuiteTargetDialog = `

## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ##
#
# Product Install Location.
# Use the following values to specify the install location for Strategy products.
# The default path of TargetDirectory is C:\\Program Files (x86)\\MicroStrategy
# The default path of COMMONFILES is C:\\Program Files (x86)\\Common Files\\MicroStrategy

[SuiteTarget]
`;

comment.commonFiles = `

[InitialPaths]
`;

comment.hideComponentSelectionDialog = `

[ComponentSelection]
`;

comment.developerVisible = `

## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ##
#
# Strategy Product Visibility State
#
# For GUI based installations, this section provides a visibility state setting for every Strategy product. 
# Legal values are:
# 
#    TRUE  - Indicates that the product is visible for selection or deselection
#    FALSE - Indicates that the product is not visible for selection or deselection
# 
# The default value for visibility state settings is "true".
#
# For example, to make "Strategy Intelligence" visible
# for selection or deselection
# 
#    IntelligenceVisible=TRUE
#
# All licensed products are visible by default, so in case you want to prevent 
# them from being visible, make sure they are set to false.

`;

comment.telemetryServerVisible = `
# New in 10.5
`;

comment.libraryWebMobileVisible = `
# New in 10.9
`;

comment.communityConnectorsVisible = `
# New in 11.0
`;

comment.exportVisible = `
# New in 11.2
`;

comment.microStrategyRepositoryVisible = `
# New in 11.3
`;

comment.storageServiceVisible = `
# New in 11.3.4 
`;

comment.developerSelect = `

## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ##
#
# Strategy Product Selection State
#
# Determines which products are installed (GUI and Silent).  A selection state setting is available for every Strategy product. 
# Legal values are:
# 
#    TRUE  - Indicates that the product is selected for installation
#    FALSE - Indicates that the product is not selected for installation
# 
# The default value for Selection state settings is "true".
#
# For example, to select "Strategy Intelligence" 
# for installation use
# 
#    IntelligenceSelect=TRUE
#
# Most licensed products are selected by default, so in case you want to prevent 
# them from being installed make sure they are unselected too.

`;

comment.telemetryServerSelect = `
# New in 10.5
`;

comment.libraryWebMobileSelect = `
# New in 10.9
`;

comment.communityConnectorsSelect = `
# New in 11.0
`;
comment.exportSelect = `
# New in 11.2
`;

comment.microStrategyRepositorySelect = `
# New in 11.3
`;

comment.storageServiceSelect = `
# New in 11.3.4 
`;

comment.hideServicesRegConfigDialog = `

## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ##
# Topology Configuration
# The Workstation Topology helps administrators to monitor and manage services 
# in a Strategy environment. Choose your configuration below.

[ServicesRegConfig]
`;

comment.hideRepositoryUpgradeDialog = `

## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ##
# Repository Upgrade
# Provide the connectivity information to be used for Repository Upgrade 
# 
# RepositoryUpgradeConfirm = To continue with the upgrade, please confirm that a backup of the Strategy Repository has been taken by typing "upgrade".

# Repository Upgrade Guide: https://www2.microstrategy.com/producthelp/Current/UpgradeGuide/en-us/Content/mstr_repository_upgrade.htm

[RepositoryUpgradeConfig]
`;

comment.hideRemoteRepositoryConfigDialog = `

## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ##
# Remote Repository Configuration

[RemoteRepositoryConfig]
`;

comment.overwriteExistingDatabaseConnectionInfo = `

## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ##
# Storage Service Configuration

[StorageServiceConfig]
`;

comment.multipleMachineEnvironment = `

# If MultipleMachineEnvironment=FALSE, this machine will be set as a server node in the environment.
# Otherwise, please specify server nodes in ServersInCluster option.
`;

comment.serversInCluster = `

# The input below will be entered identically for all configured machines in this environment.
# Example: servername1.acme.com; servername2.acme.com; servername3.acme.com
# It is recommended to configure an odd number of servers in a cluster
`;

comment.hideTelemetryServerConfigDialog = `

## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ## ##
# Telemetry Server Cluster Configuration
[TelemetryServerConfig]
`;

comment.telemetryServerLocalNode = `
# Please provide local node's hostname
`;

comment.telemetryServerRemoteNodes = `
# Please provide a semicolon separated list of remote nodes' hostname
`;

comment.hideServerDefinitionSettingDialog = `



[ServerDefinitionSetting]
`;

comment.hideAnalyticsSettingDialog = `

[AnalyticsSetting]
`;

comment.HideWebVirtualDirectoryDialog = `

[WebVirtualDirectory]
`;

comment.hideMobileVirtualDirectoryDialog = `

[MobileVirtualDirectory]
`;

comment.hideIntelligenceServiceAccountDialog = `

[IntelligenceServiceAccount]
`;

comment.hideSummaryDialog = `

[Summary]
`;

comment.hideFinishDialog = `

[Finish]
`;

export default comment;
